import React, { useState } from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { chapterTabsData } from "../../../data/SidebarData";
import Tabs from "../../../Components/Common/Tabs";
import Modal from "../../../Components/Common/Modal";
import { chapterUrls } from "../../../Api/Auth/ApiUrls";
import {
  sendPostRequestAuth,
  sendPutRequestAuth,
} from "../../../Api/swrConfig";
import { toast } from "react-toastify";
import useSWRMutation from "swr/mutation";
import useTable from "../../../hooks/useTable";
import QueryString from "qs";
import useSWR from "swr";
import useToastError from "../../../hooks/useErrorToast";
import ChapterForm from "./Components/ChapterForm";
import Table from "../../../Components/Common/Table";
import TableHead from "../../../Components/Common/TableHead";
import NoData from "../../../Components/Common/NoData";
import { Loader } from "../../../Components/Common/Loader";
import ChapterRow from "./Components/ChapterRow";
import Pagination from "../../../Components/Common/Pagination/Pagination";
import { useLocation } from "react-router-dom";

const tableColumnData = [
  { id: "no", label: "No." },
  { id: "title", label: "Title" },
  { id: "createdAt", label: "Created" },
];

const ChaptersList = () => {
  const [row, setRow] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    no: "",
    description: "",
    category: null,
  });
  const [isModalOpen, setModalOpen] = useState(false);
  const { showErrorToast } = useToastError();
  const location = useLocation();

  const actionButtons = [
    {
      label: "Create",
      icon: faAdd,
      onClick: () => {
        setRow(null);
        setFormData({
          title: "",
          no: "",
          description: "",
          category: null,
        });
        setModalOpen(true);
      },
    },
  ];

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable({ defaultOrderBy: "" });
  const apiQueryParams = {
    offset: (page - 1) * rowsPerPage,
    limit: rowsPerPage,
    sort: "no",
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);

  const { isLoading, data, mutate } = useSWR(chapterUrls.list(apiQueryString));

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Set only the field that's changed
    }));
  };

  const { trigger, isMutating } = useSWRMutation(
    chapterUrls.create,
    sendPostRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );
  const { trigger: EditTrigger, isMutating: editMutating } = useSWRMutation(
    chapterUrls.edit(row?._id),
    sendPutRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );

  const onEditClick = (row) => {
    setRow(row);

    handleInputChange("title", row.title);
    handleInputChange("description", row.description);
    handleInputChange("no", row.no);
    handleInputChange("category", row.category);
    setModalOpen(true);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (formData.no === "" || formData.no === null)
      newErrors.no = "Chapter number is required";
    if (!formData.category) newErrors.category = "Category is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const modifiedData = {
      ...formData,
      no: Number(formData.no),
      category:
        typeof formData.category === "object"
          ? formData.category.value
          : formData.category,
    };
    row ? EditTrigger(modifiedData) : trigger(modifiedData);
  };
  return (
    <div>
      <Breadcrumb actionButtons={actionButtons} />
      <Tabs tabs={chapterTabsData} />
      <Table>
        <TableHead rowCount={data?.data.length} headerData={tableColumnData} />
        <tbody className={`divide-y divide-gray-200`}>
          {!isLoading ? (
            <>
              {data?.data.map((row) => (
                <ChapterRow
                  key={row._id}
                  row={row}
                  mutate={mutate}
                  onEditClick={onEditClick}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="100" className="text-center py-4">
                <Loader />
              </td>
            </tr>
          )}
        </tbody>
        <NoData isNotFound={!data?.data.length && !isLoading} />
      </Table>
      <Pagination
        totalRows={data?.pagination.totalItems || 0}
        currentPage={page}
        rowsPerPage={rowsPerPage}
        currentPath={location.pathname}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Modal
        isOpen={isModalOpen}
        title={row ? "Edit Chapter" : "Create Chapter"}
        onConfirm={handleSubmit}
        onCancel={() => {
          setErrors({});
          setModalOpen(false);
        }}
        isLoading={isMutating || editMutating}
        formWidth
      >
        <ChapterForm
          errors={errors}
          handleSubmit={handleSubmit}
          onChange={handleInputChange}
          formData={formData}
        />
      </Modal>
    </div>
  );
};

export default ChaptersList;
